const aaa = [
  {
		path: "yujingList",
		component: () => import("@/views/caigou/yujing/yujingList.vue"),
		meta:{title:'预警提醒'},
	},
  ];
  export default aaa;
  